module.exports = __webpack_public_path__ + "static/media/申請推薦表20230413版.4166fedb.pdf";